<template>
  <layout-vertical>
    <router-view />

    <template #navbar="{ toggleVerticalMenuActive }">
      <navbar :toggle-vertical-menu-active="toggleVerticalMenuActive" />
    </template>

    <!-- <app-customizer
      v-if="showCustomizer"
      slot="customizer"
    /> -->
  </layout-vertical>
</template>

<script>
import LayoutVertical from "../layout-vertical/LayoutVertical";
// import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'
// import { $themeConfig } from '@themeConfig'
import Navbar from "../app-navbar/AppNavbarVerticalLayout";

export default {
  components: {
    // AppCustomizer,
    LayoutVertical,
    Navbar,
  },
  setup() {
    // const { skin } = useAppConfig()
    // const isDark = computed(() => skin.value === 'dark')
    // const isRTL = computed(() => skin.value === 'dark')

    // return { skin, isDark }
  },
  data() {
    return {
      // showCustomizer: $themeConfig.layout.customizer,
    };
  },
};
</script>
